import { render, staticRenderFns } from "./projectcard.component.html?vue&type=template&id=5d63f9e0&scoped=true&"
import script from "./projectcard.component.ts?vue&type=script&lang=ts&"
export * from "./projectcard.component.ts?vue&type=script&lang=ts&"
import style0 from "./projectcard.component.scss?vue&type=style&index=0&id=5d63f9e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63f9e0",
  null
  
)

export default component.exports